import { Table } from 'antd';

import { useI18n } from '../../i18n';
import { EmptyState, ErrorState, TableSkeleton } from './States';

export const DataTable = ({
  isLoading,
  isError,
  onRetry,
  columns,
  dataSource,
  rowKey = 'id',
  pageSize = 50,
  emptyVariant,
  emptyTitle,
  emptyText,
  bordered = false,
  sticky = true,
  summary,
  className = '',
  scrollX = 'max-content',
  title,
  toolbar,
  size,
}) => {
  const { t } = useI18n();
  const total = dataSource?.length ?? 0;

  let content;
  if (isLoading) {
    content = <TableSkeleton />;
  } else if (isError) {
    content = <ErrorState onRetry={onRetry} />;
  } else {
    content = (
      <Table
        bordered={bordered}
        columns={columns}
        dataSource={dataSource}
        rowKey={rowKey}
        size={size}
        sticky={sticky ? { offsetHeader: 60 } : false}
        scroll={{ x: scrollX }}
        summary={summary}
        showSorterTooltip={false}
        pagination={
          total > pageSize
            ? {
                pageSize,
                showSizeChanger: false,
                showTotal: (count, range) =>
                  t('tables.rowsTotal', { from: range[0], to: range[1], total: count }),
              }
            : false
        }
        locale={{
          emptyText: <EmptyState variant={emptyVariant} title={emptyTitle} text={emptyText} compact />,
        }}
      />
    );
  }

  return (
    <section className={`wm-card wm-table-card ${className}`}>
      {(title || toolbar) && (
        <header className='wm-card__header' style={{ paddingBottom: 14 }}>
          {title}
          {toolbar}
        </header>
      )}
      {content}
    </section>
  );
};

export const CustomTable = DataTable;
